import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const isHlsUrl = (url) => /\.m3u8(\?|$)/i.test(String(url || ''));

const VideoPlayer = ({ url, poster }) => {
    const videoRef = useRef(null);
    const hlsRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !url) return undefined;

        const destroyHls = () => {
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
        };

        destroyHls();
        video.pause();
        video.removeAttribute('src');
        video.load();

        if (isHlsUrl(url)) {
            if (Hls.isSupported()) {
                const hls = new Hls({ enableWorker: true });
                hlsRef.current = hls;
                hls.attachMedia(video);
                hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(url));
                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    video.play().catch(() => {});
                });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = url;
                video.play().catch(() => {});
            }
        } else {
            video.src = url;
            video.play().catch(() => {});
        }

        return () => {
            destroyHls();
            video.pause();
            video.removeAttribute('src');
            video.load();
        };
    }, [url]);

    return (
        <div style={{ width: '100%', height: '100%', background: '#000' }}>
            <video
                ref={videoRef}
                controls
                playsInline
                poster={poster}
                preload="metadata"
                style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: 'calc(100vh - 200px)',
                    objectFit: 'contain',
                    backgroundColor: '#000',
                }}
            />
        </div>
    );
};

export default VideoPlayer;
